<script setup>
import { computed } from 'vue';
const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const routeName = computed(() => `${props.row.original.type}_reports_show`);
</script>

<template>
  <router-link
    :to="{ name: routeName, params: { id: row.original.id } }"
    class="font-medium text-auth-text transition-colors hover:text-auth-action focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-auth-action dark:text-auth-text-dark dark:hover:text-auth-accent dark:focus-visible:ring-auth-accent"
  >
    {{ row.original.name }}
  </router-link>
</template>
